import { render, staticRenderFns } from "./jyjggzs.vue?vue&type=template&id=b0defc1e&scoped=true&"
import script from "./jyjggzs.vue?vue&type=script&lang=js&"
export * from "./jyjggzs.vue?vue&type=script&lang=js&"
import style0 from "./jyjggzs.vue?vue&type=style&index=0&id=b0defc1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0defc1e",
  null
  
)

export default component.exports